module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Žito d.o.o. icon - clear.b82cd319.svg";